import { connect } from "react-redux";
import Statements from '../components/settings/Statements';
import { fetchList } from "../store/actions/statements";
import withAuth from '../hocs/withAuth';

function mapStateToProps(state) {
  return {
    user: state.currentUser.user,
    statements: state.statements.revenues
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetch: (userId) => {
      return dispatch(fetchList(userId));
    }
  }
}

export const MyStatements = withAuth(connect(mapStateToProps, mapDispatchToProps)(Statements));



// WEBPACK FOOTER //
// ./src/containers/MyStatements.js